import React from "react";

import {
	IconAnomaly,
	IconEventCategoryActivity,
	IconEventCategoryAlert,
	IconEventCategoryChange,
	IconEventCategoryDeployment,
	IconEventCategoryOther,
} from "~/components/icon";
import { cx } from "~/tools/class-variance";

import { Api, type EventCategory } from "../../../../common/openapi";

export interface EventsItemIconProps {
	category: EventCategory;
	className?: string;
}

export const EventsItemIcon: React.FC<EventsItemIconProps> = ({ category, className }) => {
	switch (category) {
		case Api.EventCategory.Anomalies:
			return <IconAnomaly className={cx("text-red-400", className)} data-testid="anomaly-event-icon" />;
		case Api.EventCategory.Alerts:
			return <IconEventCategoryAlert className={cx("text-pink-500", className)} data-testid="alert-event-icon" />;
		case Api.EventCategory.Activities:
			return (
				<IconEventCategoryActivity className={cx("text-green-500", className)} data-testid="activity-event-icon" />
			);
		case Api.EventCategory.Changes:
			return (
				<IconEventCategoryChange className={cx("text-(--base-blue-500)", className)} data-testid="change-event-icon" />
			);
		case Api.EventCategory.Deployments:
			return (
				<IconEventCategoryDeployment className={cx("text-purple-400", className)} data-testid="change-event-icon" />
			);
		default:
			return <IconEventCategoryOther className={cx("text-graphite-500", className)} data-testid="other-event-icon" />;
	}
};
